import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn, ValidationErrors } from '@angular/forms';

// Validation function to prevent future dates
export function noFutureDateValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (!control.value) return null; // No validation if there's no value

        const selectedDate = new Date(control.value);
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Reset hours to compare only the date
        selectedDate.setHours(0, 0, 0, 0); // Reset hours to compare only the date

        return selectedDate > today ? { futureDateInvalid: true } : null; // Error if the date is in the future
    };
}

@Directive({
    selector: '[appNoFutureDateValidator]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: NoFutureDateValidatorDirective,
            multi: true
        }
    ]
})
export class NoFutureDateValidatorDirective implements Validator {
    validate(control: AbstractControl): ValidationErrors | null {
        return noFutureDateValidator()(control);
    }
}
